class VideoPlayer {
  constructor(params) {
    this.video = document.querySelector(params.video);
    this.button = document.querySelector(params.button);
    this.bannerContent = document.querySelector(params.bannerContent);
    this.poster = document.querySelector(params.poster);

    this.addEventListeners();
  }

  playPause() {
    this.button.classList.toggle("playing");
    this.poster.classList.toggle("hidden");
    if (this.bannerContent) {
      this.bannerContent.classList.toggle("hidden");
    }

    if (this.video.paused) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  reset() {
    this.button.classList.remove("playing");
    this.poster.classList.remove("hidden");
    if (this.bannerContent) {
      this.bannerContent.classList.remove("hidden");
    }
  }

  addEventListeners() {
    this.button.addEventListener("click", this.playPause.bind(this));
    this.poster.addEventListener("click", this.playPause.bind(this));
    this.video.addEventListener("ended", this.reset.bind(this));
  }
}
